<template>
  <div class="ads-space">
    <div class="header-box">
      <span class="header-label">日期</span>
      <el-date-picker v-model="date" type="daterange" align="right" unlink-panels range-separator="至"
        start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" size="small"
        value-format="yyyy-MM-dd" style="width: 230px;">
      </el-date-picker>
      <el-button type="primary" size="small" v-on:click="onQueryBtnClick">查询</el-button>
    </div>
    <el-table :data="tableData" border size="mini" style="width: 100%" cell-class-name="table-cell" row-class-name="table-row"
      header-cell-class-name="table-header-cell">
      <el-table-column prop="typeText" label="广告位">
      </el-table-column>
      <el-table-column prop="bidStrategyTypeText" label="广告活动的竞价策略">
      </el-table-column>
      <el-table-column label="竞价调整" align="right">
        <template v-slot="scope">
          <el-input placeholder="请输入内容" v-model="scope.row.bidAdjustmentRate" @change="(val) => inputChange(val, scope)"
            @focus="onFocus">
            <template slot="append">%</template>
          </el-input>
        </template>
      </el-table-column>
      <el-table-column prop="averageSpend" label="平均点击单价"  sortable align="right">
      </el-table-column>
      <el-table-column prop="impressions" label="曝光量"  sortable align="right">
      </el-table-column>
      <el-table-column prop="clicks" label="点击次数"  sortable align="right">
      </el-table-column>
      <el-table-column prop="clickRate" label="点击率（CTR）"  :formatter="percentageFormatter"  sortable :sort-method="sortClickRate" align="right">
      </el-table-column>
      <el-table-column prop="averageSpend" label="平均单击单价"  sortable :sort-method="sortAverageSpend" align="right">
      </el-table-column>
      <el-table-column prop="spend" label="花费"  sortable :sort-method="sortSpend" align="right">
      </el-table-column>
      <el-table-column prop="orders" label="订单数"  sortable align="right">
      </el-table-column>
      <el-table-column prop="sales" label="销售额"  sortable :sort-method="sortSales" align="right">
      </el-table-column>
      <el-table-column prop="acos" label="ROAS"  sortable :sort-method="sortROAS" align="right">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import {
    adsModules
  } from '@r'
  export default {

    data() {
      return {
        tableData: [],
        campaignsId: null,
        groupId: null,
        date: [],
        pickerOptions: {
          shortcuts: [
            {
              text: '今天',
              onClick (picker) {
                const end = new Date()
                const start = new Date()
                picker.$emit('pick', [start, end])
              }
            },
            {
              id: 'yesterday',
              text: '前一天',
              onClick: (picker) => {
                console.log(this);
                const end = this.date[0] || '';
                const start = this.date[1] || '';
                const newEnd = new Date(new Date(start).setTime(new Date(start).getTime() - 3600 * 1000 * 24))
                const newStart =  new Date(new Date(end).setTime(new Date(end).getTime() - 3600 * 1000 * 24))
                picker.$emit('pick', [newStart, newEnd]);
              }
            },
            {
              text: '最近一周',
              onClick (picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                picker.$emit('pick', [start, end])
              }
            }, {
              text: '最近一个月',
              onClick (picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                picker.$emit('pick', [start, end])
              }
            }, {
              text: '最近三个月',
              onClick (picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                picker.$emit('pick', [start, end])
              }
            }
          ]
        }
      }
    },
    created() {

    },
    activated() {
      this.campaignsId = this.$route.query.campaignsId - 0;
      this.groupId = this.$route.query.groupId - 0;
      const {beginDate, endDate} = this.$route.query;
      (beginDate || endDate) && (this.date = [beginDate, endDate]);
      this.queryAdsList()
    },
    methods: {
      onQueryBtnClick() {
        this.queryAdsList();
      },
      queryAdsList() {
        adsModules.getCampaignPlacementList({
          // 请求参数
          params: {
            beginIndex: this.beginIndex,
            pageSize: this.pageSize,
            campaignId: this.campaignsId,
            groupId: this.groupId,
            beginDate: this.date[0],
            endDate: this.date[1],
            dsTimeZone: 1
          }
        }).then((res) => {
          if (res.result !== 1) {
            this.$message({
              type: 'error',
              message: '列表获取失败'
            });
            return;
          }
          this.tableData = res.ldata;
        }).catch((err) => {
          this.$message({
            type: 'error',
            message: err.message ? err.message : '列表获取失败'
          });
        });
      },
      inputChange(newVal, scope) {
        this.$confirm('是否确认调整竞价?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          adsModules.updateAdCampaignsBiding({
            campaignId: this.campaignsId,
            placementType: scope.row.type,
            percentage: newVal - 0
          }).then((res) => {
            if (res.result !== 1) {
              scope.row.bidAdjustmentRate = this.focusValue;
              this.$message({
                type: 'error',
                message: res.message ? res.message : '编辑出错'
              });
              return;
            }
            this.$message({
              type: 'success',
              message: '编辑成功!'
            });
            this.queryAdsList();
          }).catch((err) => {
            this.$message({
              type: 'error',
              message: err.message ? err.message : '编辑出错'
            });
          });
        }).catch((err) => {
          scope.row.bidAdjustmentRate = this.focusValue;
          this.$message({
            type: 'info',
            message: err
          })
        })
      },
      onFocus: function(e) {
        this.focusValue = e.currentTarget.value
      },
      percentageFormatter(row, column, cellValue, index){
        if([null, undefined, ''].includes(cellValue)){
          return '--';
        }
        if(isNaN(+cellValue)){
          return cellValue;
        }
        return this.$utils.floatRide(cellValue, 100).toFixed(2) + '%';
      },
      sortClickRate(rowA, rowB){
        return parseFloat(rowA.clickRate)-parseFloat(rowB.clickRate);
      },
      sortSpend(rowA, rowB){
        return parseFloat(rowA.spend)-parseFloat(rowB.spend);
      },
      sortSales(rowA, rowB){
        return parseFloat(rowA.sales)-parseFloat(rowB.sales);
      },
      sortROAS (rowA, rowB){
        let subNumber = isNaN(parseFloat(rowA.acos)) ? 0 : parseFloat(rowA.acos);
        let nextNumber = isNaN(parseFloat(rowB.acos)) ? 0 : parseFloat(rowB.acos);
        return subNumber - nextNumber;
      },
      sortAverageSpend(rowA, rowB){
        return parseFloat(rowA.averageSpend)-parseFloat(rowB.averageSpend);
      },
    }
  }
</script>

<style lang="scss">
  .el-input .el-input-group__append {
    padding: 10px;
  }
</style>
